import { HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconArrowLoopCw } from '@dsg-tech/homefield-angular-icons';

import { CommonModule } from '@angular/common';
import { ErrorStateModule } from '@my-account/components';
import { EzApplyCreditCardComponent } from './ezapply-credit-card.component';
import { EzApplyCreditCardRoutingModule } from './ezapply-credit-card-routing.module';
import { HmfButtonComponent } from '@dsg-tech/homefield-angular';
import { NgModule } from '@angular/core';

@NgModule({
	declarations: [
		EzApplyCreditCardComponent,
	],
	imports: [
		CommonModule,
		ErrorStateModule,
		EzApplyCreditCardRoutingModule,
		HmfButtonComponent,
		HomefieldIconLibraryModule,
	]
})
export class EzApplyCreditCardModule {
	constructor(homefieldIconsLibraryService: HomefieldIconsLibraryService) {
		homefieldIconsLibraryService.registerIcons([homefieldIconArrowLoopCw]);
	}
}
